import React from 'react';
import * as S from './Footer.styles';

function Footer() {
  return (
    <S.Footer>
      <p>&copy; 2026 행복스토어. All rights reserved.</p>
      <p>사이트 내 링크로 구매하면 쿠팡으로부터 일정액의 수수료를 제공 받아 채널 운영에 도움이 됩니다.</p>
    </S.Footer>
  );
}

export default Footer;